import React, { Component } from 'react';
import BILPageHeader from 'bil-front-commons/lib/components/BILPageHeader';
import { Icon, Layout, Spin } from 'antd/lib/index';
import { FormattedMessage } from 'react-intl';

import NoAccountsLogo from'bil-front-commons/lib/ressources/images/background/no_accounts.png';
import BILHoldersUtil from 'bil-front-commons/lib/utils/BILHoldersUtil.js'
import BILHoldersSelectionList from 'bil-front-commons/lib/components/BILHolders/BILHoldersSelectionList'
import BILButtonPSD2 from 'bil-front-commons/lib/components/Button/BILButtonPSD2';

class AccountSelection_DEMO extends Component {

   constructor(props) {
      super(props)
      this.state = {
         accounts: [],
         loading: true
      }
   }

   componentDidMount() {
      var accounts = BILHoldersUtil.mockAccounts()
      this.setState({ accounts: accounts })
      this.setState({ loading: false })
   }

   componentDidUpdate() {
      BILHoldersUtil.reorganizeBorder()
   }

   render() {
      const { accounts } = this.state;
      const confirmationButtonID='BILConfirmationButton'
      const radioInputID='payment'

      var data = BILHoldersUtil.MSCashDtoToBILHoldersListDto(accounts)

      if (this.state.loading) {
         return (
            <div className="intl-spinner-container">
               <Spin
                  indicator={
                     <Icon type="loading" style={{ fontSize: 55 }} spin />
                  }
               />
            </div>
         )
      } else if (data.BILHoldersListDto.length && !this.state.loading) {
         return (
            <Layout style={{ background: 'none' }}>
               <BILPageHeader style={{ height: 'unset' }} />
               <div className="BILHoldersList-selection-container">
                  <div className="BILHoldersList-selection-container__title">
                     <FormattedMessage id="account-selection.title" />
                  </div>
                  
                  <div className="BILHoldersList-selection__" >
                     {
                        data.ownershipTypeList.map((ownershipType, i) => {
                           return (
                              <div key={i}>
                                 <div className="bil-role-title">
                                    <FormattedMessage id={"role." + BILHoldersUtil.toFrontRole(ownershipType)} />
                                 </div>
                                 {
                                    data.BILHoldersListDto.map((BILHoldersDto, i) => {
                                       if (BILHoldersDto.ownershipType === ownershipType) {
                                          return (
                                             <BILHoldersSelectionList
                                                key={ownershipType + i}
                                                BILHoldersDto={BILHoldersDto}
                                                confirmationButtonID={confirmationButtonID}
                                                radioInputID={radioInputID}
                                             />
                                          )
                                       } return null
                                    })
                                 }
                              </div>
                           )
                        })
                     }
                  </div>
                  
                  <Footer>
                     <div className="BILHolders-selection-container__button-container_footer">
                        <BILButtonPSD2
                           text={'account-selection.button-cancel'}
                           type='cancel'
                           width='185px'
                           height='50px'
                           enabled={true}
                           onClick={() => {
                              window.location = "https://developer.bil.com/validation?status=fail";
                           }} />

                        <BILButtonPSD2
                           id={confirmationButtonID}
                           text={'account-selection.button-continue'}
                           type='continue'
                           width='185px'
                           height='50px'
                           enabled={false}
                           onClick={() => {
                              var selectedIBAN = document.querySelector('input[name='+ radioInputID +']:checked')
                              if (selectedIBAN !== null) {
                                 console.log(selectedIBAN.value)
                                 //this.setState({loading : true})
                              }
                           }} />
                     </div>
                  </Footer>
               </div>
            </Layout>
         )
      } else {
         return (
            <Layout style={{ background: 'none' }}>
               <BILPageHeader />
               <div className="BILHoldersList-selection-container">
                  <div className="BILHoldersList-selection-container__title">
                     <FormattedMessage id="no-account-selection.title" />
                  </div>
                  <img src={NoAccountsLogo} className="no-accounts_logo" alt="No eligible accounts" />
               </div>
               <Footer>
                  <div className="BILHoldersList-selection-container__button-container_footer">
                     <BILButtonPSD2
                        id={'BILAbandonButton'}
                        text={'account-selection.button-cancel'}
                        type='continue'
                        width='320px'
                        height='50px'
                        enabled={true}
                        onClick={() => {
                           window.location = "https://developer.bil.com/validation?status=fail";
                        }} />
                  </div>
               </Footer>
            </Layout>
         )
      }
   }
}

const Footer = ({ children }) => {
   return (
      <div>
         <div className='BILHolders-footer__phantom' />
         <div className='BILHolders-footer'> {children} </div>
      </div>
   )
}

export default (AccountSelection_DEMO);